// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.prov-menu{
    height: 10% !important;
}
.menu-list-prov li{
 min-width: 230px !important;
}
.cont-app-list{
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}
.compact-app-list{
    width: 95%;
    height: 100%;
    display: flex;
  justify-content: center;
  align-items: center;
}
.globe-info-install{
    display: flex !important;
}
/* *************************************************************** */
.cont-logo-app{
    width: 38%;
    height: 100%;
    display: flex;
  justify-content: center;
  align-items: center;
}
.cont-info-app{
    width: 40%;
    height: 100%;
    display: flex;
  justify-content: center;
  align-items: center;
}
.iconAppLogo{
    width: 50%;
}
.cont-info-app{
    width: 60%;
    height: 100%;
    display: block;
}
.block-info-app{
    width: 100%;
    height: 33%;
    display: flex;
    justify-content: center;
    align-items: center;
    word-wrap:anywhere;
}

/* ****************************ssh*********************************** */
.cont-form-ssh{
    width: 50%;
    height: 90%;
    /* background-color: red; */

}
/* ****************************Actualizaciones*********************************** */
.cont-form-ssh{
    width: 50%;
    height: 90%;
    /* background-color: red; */

}
.btn-updates button{
    height: 3vh !important;
}`, "",{"version":3,"sources":["webpack://./src/components/provicionamiento-componentes/styles/provicionamiento.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;AAC1B;AACA;CACC,2BAA2B;AAC5B;AACA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,UAAU;IACV,YAAY;IACZ,aAAa;EACf,uBAAuB;EACvB,mBAAmB;AACrB;AACA;IACI,wBAAwB;AAC5B;AACA,oEAAoE;AACpE;IACI,UAAU;IACV,YAAY;IACZ,aAAa;EACf,uBAAuB;EACvB,mBAAmB;AACrB;AACA;IACI,UAAU;IACV,YAAY;IACZ,aAAa;EACf,uBAAuB;EACvB,mBAAmB;AACrB;AACA;IACI,UAAU;AACd;AACA;IACI,UAAU;IACV,YAAY;IACZ,cAAc;AAClB;AACA;IACI,WAAW;IACX,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA,uEAAuE;AACvE;IACI,UAAU;IACV,WAAW;IACX,2BAA2B;;AAE/B;AACA,mFAAmF;AACnF;IACI,UAAU;IACV,WAAW;IACX,2BAA2B;;AAE/B;AACA;IACI,sBAAsB;AAC1B","sourcesContent":[".prov-menu{\n    height: 10% !important;\n}\n.menu-list-prov li{\n min-width: 230px !important;\n}\n.cont-app-list{\n    width: 100%;\n    height: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n.compact-app-list{\n    width: 95%;\n    height: 100%;\n    display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.globe-info-install{\n    display: flex !important;\n}\n/* *************************************************************** */\n.cont-logo-app{\n    width: 38%;\n    height: 100%;\n    display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.cont-info-app{\n    width: 40%;\n    height: 100%;\n    display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.iconAppLogo{\n    width: 50%;\n}\n.cont-info-app{\n    width: 60%;\n    height: 100%;\n    display: block;\n}\n.block-info-app{\n    width: 100%;\n    height: 33%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    word-wrap:anywhere;\n}\n\n/* ****************************ssh*********************************** */\n.cont-form-ssh{\n    width: 50%;\n    height: 90%;\n    /* background-color: red; */\n\n}\n/* ****************************Actualizaciones*********************************** */\n.cont-form-ssh{\n    width: 50%;\n    height: 90%;\n    /* background-color: red; */\n\n}\n.btn-updates button{\n    height: 3vh !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
